import { render, staticRenderFns } from "./GameItem.vue?vue&type=template&id=541d6cd4&scoped=true&"
import script from "./GameItem.vue?vue&type=script&lang=js&"
export * from "./GameItem.vue?vue&type=script&lang=js&"
import style0 from "./GameItem.vue?vue&type=style&index=0&id=541d6cd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541d6cd4",
  null
  
)

export default component.exports